import { Component } from 'react';
import { withMewsSrcSet } from '@mews/business-components';
import { LocalizedDateTime } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { LocalizedTextTag, OptimusPlainLink } from '@mews-commander/ui';
import { Avatar, Stack } from '@optimus-web/core';
import { AVATAR_ENTITY_SIZES, AVATAR_WIDTH_SET, AVATAR_RATIO } from '../../../../components/commander-ui/constants';
import { NotificationContentWrapper, MessageWrapperElement, MessageTagWrapper } from '../style';

const AvatarWithSrcSet = withMewsSrcSet(Avatar);

interface Props {
    text?: string;
    authorImageUrl?: string;
    authorName?: string;
    createdDateTime?: {};
    isSeen?: boolean;
    onClick?: $TSFixMeFunction;
}

export default class MessageNotification extends Component<Props> {
    render() {
        const { text, authorImageUrl, authorName, createdDateTime, isSeen, onClick } = this.props;

        const avatarProps = {
            src: authorImageUrl,
            title: authorName,
            sizes: AVATAR_ENTITY_SIZES,
            ratio: AVATAR_RATIO,
            widthSet: AVATAR_WIDTH_SET,
        };

        return (
            <NotificationContentWrapper data-test-notification-type="message">
                <Stack spacing="100">
                    {/* @ts-expect-error $TSFixMeError: Type '{ src: string | undefined; title: string | undefined; sizes: string; ratio: number; widthSet: number[]; }' is not ... */}
                    <AvatarWithSrcSet {...avatarProps} size={40} />
                    <div>
                        <MessageWrapperElement>
                            {!isSeen && (
                                <MessageTagWrapper>
                                    <LocalizedTextTag variant="warning" textKey={TextKey.New} />
                                </MessageTagWrapper>
                            )}
                            {/* @ts-expect-error $TSFixMeError: Type '$TSFixMeFunction | undefined' is not assignable to type '(event: MouseEvent<Element, MouseEvent>) => void'. */}
                            <OptimusPlainLink onClick={onClick} inherit>
                                {text}
                            </OptimusPlainLink>
                        </MessageWrapperElement>
                        <LocalizedDateTime dateTime={createdDateTime} />
                    </div>
                </Stack>
            </NotificationContentWrapper>
        );
    }
}
